<template>
  <client-only>
    <div class="icons">
      <div
        v-if="adaptive.isDesktop"
        ref="search"
        class="icon"
        @click="onSearchClick"
      >
        <f-sprite-icon :icon-link="$options.icons.IconSearch" />
      </div>
      <notifications-orders v-if="isNotificationsOrderShow" />
      <control-promotions v-if="isPromotionsShown" :location="location" />
      <control-user v-if="isProfileShown" />
      <control-favorites v-if="isFavoritesShown" class="icon" />
      <control-cart v-if="isCartShown" />
    </div>
  </client-only>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import IconSearch from '@icons/search.svg';

import NotificationsOrders from '@/components/app-kit/notifications-orders';
import { commonGtmEvents } from '@/gtm/common-gtm-events';
import { isCsmAddProduct, isCsmCreateBasket } from '@/utils/cookies/csm-cookies';

import ControlCart from './control-cart.vue';
import ControlFavorites from './control-favorites';
import ControlPromotions from './control-promotions';
import ControlUser from './control-user.vue';

export default {
  name: 'menu-icons',

  components: {
    ControlPromotions,
    ControlUser,
    ControlCart,
    ControlFavorites,
    NotificationsOrders,
  },

  inject: ['adaptive'],

  props: {
    location: {
      type: String,
      default: '',
    },
  },

  icons: {
    IconSearch,
  },

  computed: {
    ...mapGetters({
      MENU: 'menu/mainMenu',
      LOGGED_IN: 'user/loggedIn',
    }),
    isSomeCsmMode() {
      return !isCsmAddProduct() && !isCsmCreateBasket();
    },
    isProfileShown() {
      return this.isSomeCsmMode && this.adaptive.isDesktop;
    },
    isPromotionsShown() {
      return this.isSomeCsmMode && this.LOGGED_IN && this.adaptive.isDesktop;
    },
    isFavoritesShown() {
      return this.isSomeCsmMode;
    },
    isCartShown() {
      return !isCsmAddProduct();
    },
    isNotificationsOrderShow() {
      return this.$isFeatureEnabled(this.featuresEnum.ACTIVE_ORDERS_WIDGET) && this.LOGGED_IN;
    },
  },

  methods: {
    ...mapActions({
      toggleSearch: 'search/toggleSearch',
    }),

    onSearchClick() {
      this.toggleSearch();
      commonGtmEvents.clickOnSearchIcon(this.$route?.fullPath);
    },
  },
};
</script>

<style lang="scss">
.icons {
  position: relative;
  display: flex;
  margin-left: auto;

  // TODO: Исправить на использование БЭМ-селекторов
  // stylelint-disable-next-line selector-max-universal
  > * {
    margin-left: 20px;
  }

  .icon {
    position: relative;
    cursor: pointer;
    height: 20px;
    width: 20px;
    .ui-badge {
      position: absolute;
      font-size: 10px;
      line-height: 17px;
      min-width: 16px;
      height: 16px;
      padding: 0 2px;
      top: -6px;
      left: 12px;
    }
  }
}

@include breakpoint("tablet") {
  .icons {
    // TODO: Исправить на использование БЭМ-селекторов
    // stylelint-disable-next-line selector-max-universal
    > * {
     margin-left: 40px;
    }
  }
}

@include breakpoint("desktop") {
  .icons {
    height: 40px;
    flex: 1 0 auto;
    justify-content: end;
    column-gap: 6.6%;

    // TODO: Исправить на использование БЭМ-селекторов
    // stylelint-disable-next-line selector-max-universal
    &:not(.checkout-header &) > * {
      margin-left: 0;
    }

    .checkout-header & {
      flex: 0 0 auto;
      column-gap: 40px;
    }

    .icon {
      width: 24px;
      height: 24px;
      margin-left: 0;

      &:first-child {
        margin-left: 0;
      }

      .ui-badge {
        font-size: 11px;
        line-height: 21px;
        min-width: 20px;
        height: 20px;
        padding: 0 6px;
        top: -10px;
        left: 14px;

        .ui-loader {
          margin: 3px -3px;
        }
      }
    }
  }
}
</style>
